/**
 * The closed set of `FormField.type` values that never collect an answer. Kept in one place so
 * every consumer that iterates `form_fields` (validation, response initialization, exports,
 * document mapping, controlling-field pickers) excludes them the same way, rather than each
 * re-deriving its own "is this a question" check.
 */

import { RICH_TEXT_CONTENT_FIELD_TYPE, type FormField } from "@/lib/database/forms";

/** `FormField.type` values that render content but collect no answer. */
export const NON_ANSWERABLE_FIELD_TYPES: readonly string[] = [RICH_TEXT_CONTENT_FIELD_TYPE];

/**
 * Whether a field collects an answer (vs. a content block, which never does). Takes only `type` (not
 * the full `FormField`) so a client-projected `{id, label, type}` shape can call this too.
 * @param field - The field to check.
 * @returns True for ordinary questions; false for non-answerable item types.
 */
export function isAnswerableField(field: Pick<FormField, "type">): boolean {
  return !NON_ANSWERABLE_FIELD_TYPES.includes(field.type);
}
